import { utils } from "ethers"
import { ProductCart } from "./cartProductTypes"
import { zeroAddress } from "viem"

const reducerEth = (
  previousValue: number,
  currentValue: ProductCart,
  ethUsd: number
) => {
  const { price, isUSD, extCallValue, currency, extRelativePrice } =
    currentValue
  const productPriceEth = isUSD
    ? Math.floor(Number(price) / (ethUsd * 100)) / 10000
    : currency === zeroAddress && Math.floor(Number(price) / 10 ** 14) / 10000

  const externalCallEth = !extRelativePrice
    ? utils.formatEther(extCallValue)
    : 0

  return previousValue + Number(productPriceEth) + Number(externalCallEth)
}

export const reducerUsdc = (
  previousValue: number,
  currentValue: ProductCart
) => {
  const { price, currency } = currentValue
  const productPriceUsdc = currency != zeroAddress ? Number(price) : 0

  return previousValue + Number(productPriceUsdc)
}

export default function getTotalPrices(cart: ProductCart[]) {
  const totalPriceEth: number = cart?.reduce(reducerEth, 0) || 0
  const totalPriceUsdc: number = cart?.reduce(reducerUsdc, 0) || 0

  return { totalPriceEth, totalPriceUsdc }
}
